import { Input } from "reactstrap";

const SearchBar = ({ onChange, className }) => {
  return (
    <div className={className}>
      <Input
        className={"bg-transparent"}
        type="search"
        placeholder="Search..."
        onChange={onChange}
      ></Input>
    </div>
  );
};

export default SearchBar;
